import { useForm } from "react-hook-form";
import { Modal, Stack, Group, Button, Text } from "@mantine/core";
import { Textarea, TextInput } from "react-hook-form-mantine";
import resolver from "@congrs/resolver";
import { extractDirtyData } from "../../utils/dirtyData";
import { useUpdateRegistrationTicketType } from "../../api/registrationTicketTypes";
import { web_updateRegistrationTicketTypeSchema } from "@congrs/schemas";
import { mergeI18nWithDefaults } from "../../utils/i18nUtils";
import LocalizedInput from "../common/LocalizedInput";

function EditTicketTypeModal({ opened, onClose, data, event }) {
  const updateType = useUpdateRegistrationTicketType(data.id);

  const mainLanguage = event?.language || "en";
  const otherLanguages = event?.secondaryLanguages || [];

  const {
    control,
    handleSubmit,
    reset,
    formState: { isDirty, dirtyFields },
  } = useForm({
    defaultValues: {
      nameI18n: mergeI18nWithDefaults(
        data.nameI18n,
        mainLanguage,
        otherLanguages
      ),
      descriptionI18n: mergeI18nWithDefaults(
        data.descriptionI18n,
        mainLanguage,
        otherLanguages
      ),
      price: data.price,
    },
    resolver: resolver(web_updateRegistrationTicketTypeSchema),
  });

  const onSubmit = (values) => {
    const payload = extractDirtyData(values, dirtyFields);
    updateType.mutate(payload, {
      onSuccess: () => {
        onClose();
      },
    });
  };

  const handleClose = () => {
    reset({
      nameI18n: mergeI18nWithDefaults(
        data.nameI18n,
        mainLanguage,
        otherLanguages
      ),
      descriptionI18n: mergeI18nWithDefaults(
        data.descriptionI18n,
        mainLanguage,
        otherLanguages
      ),
      price: data.price,
    });
    onClose();
  };

  const localizedInputFields = [
    {
      nameBase: "nameI18n",
      label: "Name",
      component: TextInput,
      props: {
        size: "sm",
        placeholder: "Ticket name",
        withAsterisk: true,
      },
    },
    {
      nameBase: "descriptionI18n",
      label: "Description",
      component: Textarea,
      props: {
        autosize: true,
        minRows: 4,
        size: "sm",
        placeholder: "Optional description",
      },
    },
  ];

  return (
    <Modal
      opened={opened}
      onClose={handleClose}
      title={<Text fw={600}>Edit Ticket Type</Text>}
      size="md"
      centered
    >
      <form onSubmit={handleSubmit(onSubmit)}>
        <Stack gap="md">
          <LocalizedInput
            control={control}
            fields={localizedInputFields}
            mainLanguage={mainLanguage}
            otherLanguages={otherLanguages}
          />

          <TextInput
            control={control}
            name="price"
            label="Price"
            placeholder="e.g. 49.99"
          />

          <Group justify="flex-end" mt="md">
            <Button variant="outline" onClick={handleClose}>
              Cancel
            </Button>
            <Button
              type="submit"
              disabled={!isDirty}
              loading={updateType.isPending}
            >
              Save Changes
            </Button>
          </Group>
        </Stack>
      </form>
    </Modal>
  );
}

export default EditTicketTypeModal;
